<template>
  <ServicePageLayout
    icon="fas fa-hands-helping"
    title="Guidance & Counseling"
    subtitle="Professional support for your personal, academic, and career growth"
  >
    <!-- Overview -->
    <section class="content-section">
      <h2>
        <i class="fas fa-info-circle section-icon" />
        Overview
      </h2>
      <p>
        The Guidance and Counseling Office provides comprehensive support services to help students
        navigate their academic journey, personal challenges, and career decisions. Our licensed
        counselors are dedicated to fostering student well-being and success.
      </p>
    </section>

    <!-- Services Offered -->
    <section class="content-section">
      <h2>
        <i class="fas fa-list-check section-icon" />
        Services Offered
      </h2>
      <div class="services-grid">
        <div class="service-card">
          <div class="card-icon green">
            <i class="fas fa-user-graduate" />
          </div>
          <h3>Academic Counseling</h3>
          <p>Support for academic concerns, study habits, and time management strategies.</p>
        </div>
        <div class="service-card">
          <div class="card-icon yellow">
            <i class="fas fa-heart" />
          </div>
          <h3>Personal Counseling</h3>
          <p>Confidential support for personal issues, stress, anxiety, and emotional concerns.</p>
        </div>
        <div class="service-card">
          <div class="card-icon green">
            <i class="fas fa-briefcase" />
          </div>
          <h3>Career Guidance</h3>
          <p>Career exploration, aptitude assessment, and vocational planning assistance.</p>
        </div>
        <div class="service-card">
          <div class="card-icon yellow">
            <i class="fas fa-users" />
          </div>
          <h3>Group Sessions</h3>
          <p>Workshops and group activities focusing on personal development and life skills.</p>
        </div>
      </div>
    </section>

    <!-- Schedule -->
    <section class="content-section">
      <h2>
        <i class="fas fa-calendar-alt section-icon" />
        Office Hours
      </h2>
      <div class="schedule-card">
        <div class="schedule-row">
          <span class="day">Monday - Friday</span>
          <span class="time">8:00 AM - 5:00 PM</span>
        </div>
        <div class="schedule-row">
          <span class="day">Saturday</span>
          <span class="time">By Appointment Only</span>
        </div>
        <div class="schedule-row">
          <span class="day">Sunday</span>
          <span class="time">Closed</span>
        </div>
      </div>
    </section>

    <!-- Contact -->
    <section class="content-section">
      <h2>
        <i class="fas fa-phone section-icon" />
        Contact Information
      </h2>
      <div class="contact-info">
        <div class="contact-item">
          <i class="fas fa-map-marker-alt" />
          <span>Room 201, Student Services Building</span>
        </div>
        <div class="contact-item">
          <i class="fas fa-phone" />
          <span>(078) 123-4567 Local 201</span>
        </div>
        <div class="contact-item">
          <i class="fas fa-envelope" />
          <span>counseling@nc.edu.ph</span>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="cta-section">
      <h2>Need to Talk?</h2>
      <p>Book a confidential session with one of our counselors today.</p>
      <button
        class="cta-button"
        @click="bookAppointment"
      >
        <i class="fas fa-calendar-plus" />
        Schedule Appointment
      </button>
    </section>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/landing/ServicePageLayout.vue'

export default {
  name: 'CounselingService',

  components: {
    ServicePageLayout
  },

  metaInfo: () => ({
    title: 'Guidance & Counseling'
  }),

  methods: {
    bookAppointment () {
      this.$bvToast.toast('Appointment booking coming soon!', {
        title: 'Coming Soon',
        variant: 'info',
        solid: true
      })
    }
  }
}
</script>
